import styled from "styled-components";
import { Typography } from "@mui/material";
import selectedTheme from "../../themes";

export const MenuItemText = styled(Typography)`
  font-family: ${selectedTheme.fonts.textFont};
  margin-left: 10px;
`;
